import { JsonBlock, NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

type CustomDataPropertyValueProps = {
  value: unknown;
};

export const CustomDataPropertyValue = ({ value }: CustomDataPropertyValueProps) => {
  if (value === null) {
    return NO_DATA_PLACEHOLDER;
  }

  if (typeof value === 'object') {
    return <JsonBlock object={value} />;
  }

  return String(value);
};
